import React from 'react';
import { Modal, ModalBody, Form, FormGroup, CustomInput, Label } from 'reactstrap';
import { userActions } from '../../../core/users';
import { useDispatch, useSelector } from 'react-redux';
import { DEFAULT_PRIVACY_POLICY_URL, DEFAULT_TERMS_OF_USE_URL } from '../../../core/constants';

export const PopupAcceptTerms = ({ isOpen, toggle }) => {
    const dispatch = useDispatch()
    const systemCheck = useSelector(state => state?.systemCheck?.data?.data)
    const termsOfUseUrl = systemCheck?.terms_of_use_url || DEFAULT_TERMS_OF_USE_URL
    const privacyPolicyUrl = systemCheck?.privacy_policy_url || DEFAULT_PRIVACY_POLICY_URL

    const acceptTerms = () => {
        dispatch(userActions.acceptTerms())
    }

    return (
        <Modal isOpen={isOpen}>
            <ModalBody>
                <Form className='mt-3'>
                    <h5 className='text-center text-reset'>To continue using My True Advance, please agree to True Advance's updated Terms of Use and Privacy Policy</h5>
                    <FormGroup>
                        <CustomInput className="pl-0 ml-4 styled-checkbox d-flex align-items-center" type="checkbox" id="termsAndPrivacy" onChange={() => acceptTerms()} label={<Label for='termsAndPrivacy' >I agree to True Advance's <a href={termsOfUseUrl} target='_blank' rel='noreferrer'>Terms of Use</a> and <a href={privacyPolicyUrl} target='_blank' rel='noreferrer'>Privacy Policy</a></Label>} />
                    </FormGroup>
                </Form>
            </ModalBody>
        </Modal>
    )
}